
  import { defineComponent, onMounted, ref } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { NewsObject } from '@/store/modules/Assets/NewsModule';
  import { useAbility } from '@casl/vue';
  import * as Yup from 'yup';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  export default defineComponent({
    name: 'news-editing',
    components: {
      ErrorMessage,
      Field,
      Form,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const { can } = useAbility();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const uploadedFile = ref<File | null>(null);
      const previewImage = ref<string>('');
      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('newsUpdating'), [
          translate('assets'),
        ]);
      });
      const { data } = await store.dispatch(
        Actions.GET_ONE_NEWS,
        route.params.id
      );
      const news = ref<NewsObject>(data.data);
      const translate = (text: string) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };
      const goBack = () => {
        router.back();
      };
      const handleFileUpload = (event: Event) => {
        const target = event.target as HTMLInputElement;
        const file = target.files?.[0];
        if (file) {
          uploadedFile.value = file;
          // Create preview URL
          const reader = new FileReader();
          reader.onload = (e) => {
            previewImage.value = e.target?.result as string;
          };
          reader.readAsDataURL(file);
        }
      };
      const validationSchema = Yup.object().shape({
        titleEn: Yup.string()
          .required(() => translate('EN_NAME_IS_REQUIRED_FIELD'))
          .label('English Name'),
        titleAr: Yup.string()
          .required(() => translate('AR_NAME_IS_REQUIRED_FIELD'))
          .label('Arabic Name'),
        externalLink: Yup.string()
          .required(() => translate('EXTERNAL_LINK_IS_REQUIRED_FIELD'))
          .label('External Link'),
        thumbnail: Yup.string()
          .required(() => translate('IMAGE_URL_IS_REQUIRED_FIELD'))
          .label('Image URL'),
      });
      const onSubmitUpdate = async (values) => {
        if (submitButton.value) {
          // eslint-disable-next-line
        submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }
        let logoFormData;
        if (uploadedFile.value) {
          logoFormData = new FormData();
          logoFormData.append('images', uploadedFile.value);
        }
        if (news.value.readTime) values.readTime = Number(values.readTime);
        await store.dispatch(Actions.UPDATE_NEWS, {
          id: news.value?.id,
          data: values,
        });
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];
        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          //Deactivate indicator
          submitButton.value?.removeAttribute('data-kt-indicator');
          // eslint-disable-next-line
        submitButton.value!.disabled = false;
        } else {
          if (logoFormData) {
            await store.dispatch(Actions.UPLOAD_NEWS_THUMBNAIL, {
              data: logoFormData,
              id: news.value?.id,
            });
          }
          Swal.fire({
            text: translate('SUCCESSFULLY_UPDATED_NEWS'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            router.push({ name: 'news-listing' });
          });
        }
      };
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');
      return {
        onSubmitUpdate,
        validationSchema,
        handleFileUpload,
        submitButton,
        previewImage,
        translate,
        goBack,
        news,
        can,
      };
    },
  });
